import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { getUserListItemContentAdditionalText } from '../../../utils/user'
import { Divider, DIVIDER_STYLE } from '../../Divider'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'

import * as styles from './MyRequestTaskWidgetItemContent.module.css'

function MyRequestTaskWidgetItemContent({
  building,
  children,
  className = styles.MyRequestTaskWidgetItemContent,
  flat,
  owner,
  text,
  textClassName = styles.text,
  onClickTitle,
}) {
  const { t } = useTranslation()

  const {
    overflow: overflowAddress,
    setContentOverflowRef: setAddressContentOverflowRef,
  } = useContentOverflow()

  const {
    overflow: overflowOwner,
    setContentOverflowRef: setOwnerContentOverflowRef,
  } = useContentOverflow()

  const ownerContent =
    owner.fullname + getUserListItemContentAdditionalText({ role: owner.role })

  return (
    <div className={className}>
      <FloatingTooltip
        content={
          <FloatingTooltipContentText
            additionalText={t('Common.ClickToOpenProfileKey')}
            text={text}
          />
        }
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <Text className={textClassName} onClick={onClickTitle}>
          {text}
        </Text>
      </FloatingTooltip>

      <FloatingTooltip
        content={building}
        disabled={!overflowAddress}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <div className={styles.addressRow}>
          <Text
            isSecondary
            className={styles.building}
            ref={setAddressContentOverflowRef}
          >
            {building}
          </Text>
          {flat ? (
            <>
              <Divider className={styles.divider} style={DIVIDER_STYLE.Round} />
              <Text isSecondary className={styles.flat}>
                {t('Common.FlatSelectListItemNumberPrefixKey')}
                {flat}
              </Text>
            </>
          ) : null}
        </div>
      </FloatingTooltip>
      {owner ? (
        <FloatingTooltip
          content={ownerContent}
          disabled={!overflowOwner}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text
            isSecondary
            className={styles.owner}
            ref={setOwnerContentOverflowRef}
          >
            {ownerContent}
          </Text>
        </FloatingTooltip>
      ) : null}

      {children}
    </div>
  )
}

export default MyRequestTaskWidgetItemContent
